import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'rank618',//20207月抽奖活动
      component: resolve => require(['@/views/Rank618.vue'], resolve)
    },
    {
      path: '/myLuckyRecord',
      name: 'myLuckyRecord',//我的抽奖记录
      component: resolve => require(['@/views/MyLuckyRecord.vue'], resolve)
    },
    {
      path: '/submitForm',
      name: 'submitForm',
      component: resolve => require(['@/views/SubmitForm.vue'], resolve)
    },
    {
      path: '/inviteRank',
      name: 'inviteRank',//20207月底邀请人排行榜
      component: resolve => require(['@/views/InviteRank.vue'], resolve)
    },
    {
      path: '/gridTable2020',
      name: 'gridTable2020',//20207月抽奖活动
      component: resolve => require(['@/views/GridTable2020.vue'], resolve)
    },
    {
      path: '/singleDay2019',
      name: 'singleDay2019',//双十一活动
      component: resolve => require(['@/views/SingleDay2019.vue'], resolve)
    },
    {
      path: '/singleDay2023',
      name: 'singleDay2023',//2023双十一活动
      component: resolve => require(['@/views/SingleDay2023.vue'], resolve)
    },
    {
      path: '/kaixueji',
      name: 'kaixueji',//小古文领取优惠券
      component: resolve => require(['@/views/Kaixueji.vue'], resolve)
    },
    {
      path: '/lecturerList',
      name: 'lecturerList',//2022讲师榜单
      component: resolve => require(['@/views/lecturerList.vue'], resolve)
    },
    {
      path: '/manjian',
      name: 'manjian',//小古文领取优惠券
      component: resolve => require(['@/views/Manjian.vue'], resolve)
    },
    {
      path: '/couponPacket',
      name: 'couponPacket',//小古文领取优惠券
      component: resolve => require(['@/views/couponPacket.vue'], resolve)
    },
    {
      path: '/sharePacket',
      name: 'sharePacket',//小古文分享领红包
      component: resolve => require(['@/views/SharePacket.vue'], resolve)
    },
    {
      path: '/newGift',
      name: 'newGift',
      component: resolve => require(['@/views/NewGift.vue'], resolve)
    },
    {
      path: '/oldGift',
      name: 'oldGift',
      component: resolve => require(['@/views/OldGift.vue'], resolve)
    },
    {
      path: '/childrenDay',
      name: 'childrenDay',
      component: resolve => require(['@/views/SwiperGift.vue'], resolve)
    },
    {
      path: '/exchangeOrder',
      name: 'exchangeOrder',
      component: resolve => require(['@/views/ExchangeOrder.vue'], resolve)
    },
    {
      path: '/courseActivitie',
      name: 'courseActivitie',
      component: resolve => require(['@/views/CourseActivitie.vue'], resolve)
    },
    {
      path: '/wxMini',
      name: 'wxMini',
      component: resolve => require(['@/views/WxMini.vue'], resolve)
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js